import { useState, useEffect } from 'react';

import * as Styles from './Switch.styles';

const Switch = ({ formik, defaultChecked = false, label, name, onChange }) => {
  const [checked, setChecked] = useState(
    formik?.values?.[name] || defaultChecked
  );

  useEffect(() => {
    if (defaultChecked !== checked) {
      setChecked(defaultChecked);
    }
  }, [defaultChecked]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    if (onChange) {
      onChange(event.target.checked);
    }
    if (formik) {
      formik.handleChange(event);
    }
  };

  return (
    <Styles.Wrapper>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleChange}
        className="switch-input"
      />
      <span className="el-switch-style"></span>
      <span className="text-gray-700 dark:text-gray-400 text-sm ml-2">
        {label}
      </span>
    </Styles.Wrapper>
  );
};

export default Switch;
